import { savedAudienceService } from '@marketing-milk/frontend'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { getApiErrorMessage } from 'app/util'

/**
 * Re-pulls the connected ad account's audiences and re-evaluates which of ours it still holds.
 */
export function useRefreshAudienceAvailability(businessID: string) {
  const queryClient = useQueryClient()

  return useMutation(() => savedAudienceService.refreshAvailability(businessID), {
    onSuccess: () => queryClient.invalidateQueries(['audiences', businessID]),
    onError: (err: unknown) => {
      toast.error(getApiErrorMessage(err, 'Could not re-sync audiences. Please try again.'))
    },
  })
}
